import { Fragment, useContext, useEffect, useState } from "react";
import { DataContext } from "../../../pages/ConfiguraHyundai";
import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { IoCarSport } from "react-icons/io5";
import { BsArrowLeftRight } from "react-icons/bs";
import { VscClose } from "react-icons/vsc";
import { ListGroup } from "react-bootstrap";
import { Server } from "../../../../constants";
import axios from "axios";
import AnimatedNumber from 'react-animated-number';
import AOS from "aos";
import { Box, Modal } from "@material-ui/core";
import "../pagesGlabal.css";
import Form from "react-bootstrap/Form";
import Image from "react-bootstrap/Image";

const Versiones = (props) => {

    const {
        setAccesoriosIndividuales,
        setKits,
        modeloSeleccionado,
        setModeloSeleccionado
    } = useContext(DataContext);
    const [versionSeleccionada, setVersionSeleccionada] = useState(undefined);
    const [colorSeleccionado, setColorSeleccionado] = useState(undefined);
    const [isOpen, setOpen] = useState(false);
    //Lista de objetos
    const [colores, setColores] = useState([]);
    const [versiones, setVersiones] = useState([]);
    const [detallesVersion, setDetallesVersion] = useState([]);
    const [imagen, setImagen] = useState(null);
    const [imagenCargada, setImagenCargada] = useState(false);

    useEffect(() => {
        AOS.init({
            duration: 2000,
            once: true
        });
        const obtenerDetallesModeloSeleccionado = (carId) => {
            setKits([]);
            setAccesoriosIndividuales([]);
            const url = `${Server}/api/configura/detalles-modelo/${carId}`
            return axios
                .get(url)
                .then(async (response) => {
                    let detallesModelo = response.data.data;
                    setVersiones(detallesModelo.MOD_VERSIONES);
                    setColores(detallesModelo.MOD_COLORES);
                    var colorSeleccionado = ""
                    var versionSeleccionada = ""
                    if (!modeloSeleccionado?.colorSeleccionado) {
                        setColorSeleccionado(detallesModelo.MOD_COLORES[0]);
                        colorSeleccionado = detallesModelo.MOD_COLORES[0];
                    } else {
                        colorSeleccionado = modeloSeleccionado.colorSeleccionado;
                    }
                    if (!modeloSeleccionado?.versionSeleccionada) {
                        setVersionSeleccionada(detallesModelo.MOD_VERSIONES[0]);
                        let detallesVersionInicial = detallesModelo.MOD_VERSIONES[0]?.VER_DETALLES?.split("|")
                        setDetallesVersion(detallesVersionInicial);
                        estilosVersion(detallesModelo.MOD_VERSIONES[0].VER_CODIGO);
                        versionSeleccionada = detallesModelo.MOD_VERSIONES[0]
                    } else {
                        setVersionSeleccionada(modeloSeleccionado.versionSeleccionada);
                        versionSeleccionada = modeloSeleccionado.versionSeleccionada
                        estilosVersion(modeloSeleccionado.versionSeleccionada.VER_CODIGO);
                        let detallesVersionSeleccionado = modeloSeleccionado.versionSeleccionada.VER_DETALLES.split("|")
                        setDetallesVersion(detallesVersionSeleccionado);
                    }
                    console.log('Intentando cargar imagen:', {
                        modeloCodigo: modeloSeleccionado.MOD_CODIGO,
                        colorSeleccionado: colorSeleccionado,
                        colorSeleccionadoVAC_COLOR: colorSeleccionado?.VAC_COLOR,
                        ruta: `../../../../images/colores/${modeloSeleccionado.MOD_CODIGO}/${colorSeleccionado?.VAC_COLOR || colorSeleccionado}.webp`
                    });
                    try {
                        let imgColor = require(`../../../../images/colores/${modeloSeleccionado.MOD_CODIGO}/${colorSeleccionado?.VAC_COLOR || colorSeleccionado}.webp`);
                        setImagen(imgColor);
                        setImagenCargada(true);
                    } catch (error) {
                        console.error('Error al cargar imagen:', error);
                        try {
                            if (detallesModelo.MOD_COLORES && detallesModelo.MOD_COLORES.length > 0) {
                                console.log('Intentando con color por defecto:', detallesModelo.MOD_COLORES[0].VAC_COLOR);
                                let imgColorDefault = require(`../../../../images/colores/${modeloSeleccionado.MOD_CODIGO}/${detallesModelo.MOD_COLORES[0].VAC_COLOR}.webp`);
                                setImagen(imgColorDefault);
                                setImagenCargada(true);
                            } else {
                                setImagen(null);
                                setImagenCargada(true);
                            }
                        } catch (defaultError) {
                            console.error('Error al cargar imagen por defecto:', defaultError);
                            setImagen(null);
                            setImagenCargada(true);
                        }
                    }
                    await setModeloSeleccionado({
                        ...modeloSeleccionado,
                        colorSeleccionado,
                        versionSeleccionada
                    })
                })
                .catch(function (error) {
                })
        }
        if (versiones?.length === 0) {
            obtenerDetallesModeloSeleccionado(modeloSeleccionado.MOD_CODIGO);
        }
    }, [modeloSeleccionado, setAccesoriosIndividuales, setKits, setModeloSeleccionado, versiones]);

    const seleccionarVersion = (versionSeleccionada) => {
        setVersionSeleccionada(versionSeleccionada);
        let detallesVersionInicial = versionSeleccionada?.VER_DETALLES?.split("|")
        setDetallesVersion(detallesVersionInicial);
        setModeloSeleccionado({
            ...modeloSeleccionado,
            versionSeleccionada
        })
    }

    const estilosVersion = (value) => {
        var elements = document.querySelectorAll(".version-seleccionada");
        elements.forEach((version) => {
            if (version.id === "button" + value) {
                version.style.backgroundColor = "#212d58";
                version.style.color = "#fff";
            } else {
                version.style.color = "#000";
                version.style.backgroundColor = "#fff";
            }
        })
    }

    const seleccionarColor = (codColor) => {
        var nuevaLista = colores.map((colorSeleccionado) => {
            colorSeleccionado.VAC_DEFECTO = false;
            if (colorSeleccionado.VAC_COLOR === codColor) {
                colorSeleccionado.VAC_DEFECTO = true;
                setColorSeleccionado(colorSeleccionado);
                console.log('Intentando cargar imagen en seleccionarColor:', {
                    modeloCodigo: modeloSeleccionado.MOD_CODIGO,
                    codColor: codColor,
                    ruta: `../../../../images/colores/${modeloSeleccionado.MOD_CODIGO}/${codColor}.webp`
                });
                try {
                    let imgColor = require(`../../../../images/colores/${modeloSeleccionado.MOD_CODIGO}/${codColor}.webp`);
                    setImagen(imgColor);
                    setImagenCargada(true);
                } catch (error) {
                    console.error('Error al cargar imagen:', error);
                    try {
                        if (colores && colores.length > 0) {
                            let imgColorDefault = require(`../../../../images/colores/${modeloSeleccionado.MOD_CODIGO}/${colores[0].VAC_COLOR}.webp`);
                            setImagen(imgColorDefault);
                            setImagenCargada(true);
                        } else {
                            setImagen(null);
                            setImagenCargada(true); 
                        }
                    } catch (defaultError) {
                        console.error('Error al cargar imagen por defecto:', defaultError);
                        setImagen(null);
                        setImagenCargada(true);
                    }
                }
                setModeloSeleccionado({
                    ...modeloSeleccionado,
                    colorSeleccionado
                })
            }
            return colorSeleccionado;
        })
        setColores(nuevaLista);
    };

    return (
        <Fragment>
            <section>
                <Card className='card-vehicle-information' style={{ width: '100%' }}>
                    <Card.Body className="card-information-body">
                        <Row>
                            <Col lg={3} xs={12}>
                                <p className="h-head-of h18 pt-1">Versiones disponibles</p>
                                <ListGroup variant="bg-gray-color-v2">
                                    {versiones.map((version) => (
                                        <ListGroup.Item
                                            id={"button" + version.VER_CODIGO}
                                            key={version.VER_CODIGO}
                                            action
                                            onClick={() => {
                                                seleccionarVersion(version);
                                                estilosVersion(version.VER_CODIGO);
                                            }}
                                            className="version-seleccionada"
                                        >
                                            <p className="h-head-l m-0">
                                                <IoCarSport className="h18 "></IoCarSport>
                                                {" " + version.VER_NOMBRE}</p>
                                        </ListGroup.Item>
                                    )
                                    )}
                                </ListGroup>
                                <p className="text-right text-comparar-version"
                                    onClick={() => setOpen(true)}
                                >
                                    Comparar versiones
                                    <BsArrowLeftRight className='ml-3' />
                                </p>
                                <div className="cotizador pt-2">
                                    <div>
                                        <p className="h-head-of h18">Colores disponibles</p>
                                    </div>
                                    <div className="color-option text-center">
                                        <ul>
                                            {colores.map((color) => (
                                                <li
                                                    key={color.VAC_COLOR}
                                                    value={color.COL_NOMBRE}
                                                    style={{
                                                        backgroundColor: `${color.COL_REF_HEX}`,
                                                    }}
                                                    onClick={() => {
                                                        seleccionarColor(color.VAC_COLOR);
                                                    }}
                                                ></li>
                                            ))}
                                        </ul>
                                        <p className="text-center h-head-l h16">{colorSeleccionado?.COL_NOMBRE}</p>
                                    </div>
                                </div>
                            </Col>
                            <Col lg={6} xs={12} >
                                <center>
                                    {imagenCargada && imagen ? (
                                        <Image className="img-ve" src={imagen} alt="Hyundai vehiculo" width={350} height={200} />
                                    ) : (
                                        <div className="img-ve" style={{ 
                                            width: '510px', 
                                            height: '260px', 
                                            backgroundColor: '#f5f5f5', 
                                            display: 'flex', 
                                            alignItems: 'center', 
                                            justifyContent: 'center',
                                            border: '1px solid #ddd'
                                        }}>
                                            <p style={{ color: '#666', fontSize: '16px' }}>
                                                {imagenCargada ? 'Imagen no disponible' : 'Cargando imagen...'}
                                            </p>
                                        </div>
                                    )}
                                </center>
                                <Form.Row className="d-block d-md-none">
                                    <Form.Group as={Col} md="12" className="mb-0">
                                    </Form.Group>
                                </Form.Row>
                            </Col>
                            <Col lg={3} xs={12}>
                                <Row>
                                    <Col xs={12} lg={5}>
                                        <p className="h-head-of h18">Precio Base: </p>
                                    </Col>
                                    <Col xs={12} lg={7}>
                                        <AnimatedNumber
                                            value={versionSeleccionada?.VEA_PRECIO_PVP}
                                            className="h24 h-txt-r"
                                            formatValue={n => n.toLocaleString('en-US', {
                                                style: 'currency',
                                                currency: 'USD'
                                            })}
                                            // duration={300}
                                            frameStyle={perc => (
                                                perc > 20 && perc < 80 ? { opacity: 0.5 } : {}
                                            )}
                                        />
                                    </Col>
                                </Row>
                                <hr />
                                <div>
                                    <p className="h-head-of h18 mr-5">Características</p>
                                    <ul style={{ paddingLeft: '20px' }}>
                                        {
                                            detallesVersion?.map((detalle, index) => {
                                                return (

                                                    <li data-aos="fade-right" key={index} className="h14 h-txt-r">
                                                        {detalle}
                                                    </li>
                                                )
                                            })
                                        }
                                    </ul>
                                </div>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
                <Modal
                    open={isOpen}
                    onClose={() => setOpen(false)}
                    className='centrar-global'
                >
                    <Box className="box-scroll-versiones">
                        <Card className='card-vehicle-information'>
                            <Row className="text-right pt-3 bg-sand header-comparar-version">
                                <div>
                                    <p className="text-center"><b className="h20 h-txt-r">
                                        {modeloSeleccionado?.MOD_NOMBRE}
                                    </b>
                                        {/*{" 2022"}*/}
                                        <span className="h18 ml-2">{modeloSeleccionado?.CM_ANIO}</span>
                                    </p>
                                </div>
                                <div>
                                    <VscClose
                                        onClick={() => setOpen(false)}
                                        className="close-button"
                                    />
                                </div>
                            </Row>
                            <Card.Body className="card-information-body">
                                <Row>
                                    {versiones.map(
                                        (version) => {
                                            var listaDetalles = version.VER_DETALLES?.split("|");
                                            return (
                                                <Col key={version.VER_CODIGO} xs={12} md={12 / versiones.length}>
                                                    <div>
                                                        <h1 className="h-head-of h18 text-center">
                                                            {version.VER_NOMBRE}
                                                        </h1>
                                                        <h5 className="h-head-of h18 text-center">
                                                            {version.VEA_PRECIO_PVP.toLocaleString("en-US", {
                                                                style: 'currency',
                                                                currency: 'USD'
                                                            })}
                                                        </h5>
                                                    </div>
                                                    <hr />
                                                    <ul style={{ paddingLeft: '15px' }} data-aos="fade-up">
                                                        {
                                                            listaDetalles?.map((item, index) => {
                                                                return <li key={index}>{item}</li>
                                                            })
                                                        }
                                                    </ul>
                                                </Col>
                                            )
                                        }
                                    )}
                                </Row>
                            </Card.Body>
                        </Card>
                    </Box>
                </Modal>
            </section>
        </Fragment>
    )
}
export default Versiones;